import { Cookies } from 'react-cookie';

import { ObjectDocFormValues } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface ObjectDocAdd {
  document: ObjectDocFormValues;
  slug: string;
}

export interface CreatedObjectDoc {
  message: string;
}

export const createObjectDoc = async ({ document, slug }: ObjectDocAdd) => {
  const cookie = new Cookies();
  const token = cookie.get('local_access_token');

  const formData = new FormData();
  formData.append('doc_name', document.doc_name);
  formData.append('file', document.file);

  const data = await axiosInterceptor.post(`/object-docs/${slug}/add-document/`, formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as CreatedObjectDoc;
};
